import React from 'react'
import PropTypes from 'prop-types'
import Grid from '../../Grid'
import Typography from '../../Typography'
import styles from './ErrorMessage.module.sass'

const ErrorMessage = ({ text }) => {
  const DISPLAY_TEXT = text

  return (
    <Grid container item direction="column" classes={styles.errorContainer}>
      <Typography>{DISPLAY_TEXT.message}</Typography>
      <ul className={styles.list}>
        <li>Retry</li>
        {DISPLAY_TEXT.callToAction && <li>{DISPLAY_TEXT.callToAction}</li>}
        <li>
          or call
          {' '}
          <a className={styles.link} href="tel:209-567-0748">(209) 567-0748</a>
          {' '}
          for assistance.
        </li>
      </ul>
    </Grid>
  )
}

ErrorMessage.defaultProps = {
  accessCodeOnly: false,
}

ErrorMessage.propTypes = {
  accessCodeOnly: PropTypes.bool,
}

export default ErrorMessage
